import axios from 'axios';

// ── Base instance pointing to Express on port 5500 ────────────────────────
const API = axios.create({
  baseURL: 'http://localhost:5500/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

// Attach JWT token to every request automatically
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('garageToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Global response error handler
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('garageToken');
      localStorage.removeItem('garageUser');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ── AUTH ──────────────────────────────────────────────────────────────────
export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  getMe: () => API.get('/auth/me'),
  getAllUsers: () => API.get('/auth/users'),
};

// ── VEHICLES ──────────────────────────────────────────────────────────────
export const vehicleAPI = {
  getAll: () => API.get('/vehicles'),
  getOne: (id) => API.get(`/vehicles/${id}`),
  create: (data) => API.post('/vehicles', data),
  update: (id, data) => API.put(`/vehicles/${id}`, data),
  delete: (id) => API.delete(`/vehicles/${id}`),
};

// ── BOOKINGS ──────────────────────────────────────────────────────────────
export const bookingAPI = {
  getSlots: (date) => API.get(`/bookings/slots?date=${date}`),
  getStats: () => API.get('/bookings/stats'),
  getAll: (params) => API.get('/bookings', { params }),
  getOne: (id) => API.get(`/bookings/${id}`),
  create: (data) => API.post('/bookings', data),
  update: (id, data) => API.put(`/bookings/${id}`, data),
  cancel: (id) => API.delete(`/bookings/${id}`),
};

// ── INVENTORY ─────────────────────────────────────────────────────────────
export const inventoryAPI = {
  getStats: () => API.get('/inventory/stats'),
  getAll: (params) => API.get('/inventory', { params }),
  getOne: (id) => API.get(`/inventory/${id}`),
  create: (data) => API.post('/inventory', data),
  update: (id, data) => API.put(`/inventory/${id}`, data),
  adjustStock: (id, data) => API.patch(`/inventory/${id}/stock`, data),
  delete: (id) => API.delete(`/inventory/${id}`),
};

// ── INVOICES ──────────────────────────────────────────────────────────────
export const invoiceAPI = {
  getStats: () => API.get('/invoices/stats'),
  getAll: (params) => API.get('/invoices', { params }),
  getOne: (id) => API.get(`/invoices/${id}`),
  create: (data) => API.post('/invoices', data),
  updatePayment: (id, data) => API.patch(`/invoices/${id}/payment`, data),
};

// ── ALERTS ────────────────────────────────────────────────────────────────
export const alertAPI = {
  getAll: (params) => API.get('/alerts', { params }),
  markRead: (id) => API.patch(`/alerts/${id}/read`),
  markAllRead: () => API.patch('/alerts/read-all'),
  resolve: (id) => API.patch(`/alerts/${id}/resolve`),
  generateServiceAlerts: () => API.post('/alerts/generate-service-alerts'),
  delete: (id) => API.delete(`/alerts/${id}`),
};

export default API;